import { memo } from "react"
import { Box, Container, Heading, Text, VStack, Tag, HStack } from "@chakra-ui/react"
import { CustomButton } from "@app/components/Button"
import { CheckIcon } from "@chakra-ui/icons"
import { Swiper, SwiperSlide } from "swiper/react"
import { CurvedTitle } from "@components/CurvedTitle"

const Benefits: React.FC<GatsbyTypes.SanitySectionBenefits> = ({ description, benefitGroups, bgColor, button, title }) => {
  const hasBenefits = !!benefitGroups?.length

  return (
    <Box bgColor={bgColor} py={[10, 18]}>
      <Container>
        <Box textAlign="center" maxW={96} mx="auto">
          {title && (
            <Heading as="p" size="h2">
              {title}
            </Heading>
          )}
          {description && <Text mt={2}>{description}</Text>}
        </Box>
      </Container>

      <Box py={[5, 12]}>
        <Swiper
          pagination={{ clickable: true }}
          slidesPerView="auto"
          centeredSlides
          initialSlide={1}
          breakpoints={{ 1200: { slidesPerView: 4, slidesPerGroup: 4, centeredSlides: false } }}
        >
          {hasBenefits &&
            benefitGroups?.map((benefitGroup, index) => {
              const slideClasses = ["no-flex"]
              if (index === 0) {
                slideClasses.push("first-xl")
              }
              if (index === benefitGroups.length - 1) {
                slideClasses.push("last-xl")
              }
              return (
                <SwiperSlide key={benefitGroup?._key} className={slideClasses.join(" ")}>
                  <VStack w={[60, 68]} h="full" bg={benefitGroup?.bgColor} pt={12} pb={27} px={7} borderRadius="130px" mx={[1, 4]}>
                    {benefitGroup?.title && <CurvedTitle title={benefitGroup?.title} />}
                    <Tag variant="benefits" bgColor={benefitGroup?.tag?.bgColor}>
                      {benefitGroup?.tag?.title}
                    </Tag>
                    <Box pt={6}>
                      {benefitGroup?.benefitList?.map((benefit: any) => (
                        <HStack key={benefit} alignItems="flex-start" spacing={0}>
                          <CheckIcon mr={3} w={2.5} />
                          <Text textAlign="left" pb={2} fontSize={["sm", "md"]}>
                            {benefit}
                          </Text>
                        </HStack>
                      ))}
                    </Box>
                  </VStack>
                </SwiperSlide>
              )
            })}
        </Swiper>
      </Box>
      <CustomButton button={button} center />
    </Box>
  )
}

export default memo(Benefits)
